import { EventManager } from '../../utilities/events';
import { ContextConsumer } from '@lit/context';
import { memberContext } from '../../utilities/context';
export const AllInMemberConsumer = (superClass) => class extends superClass {
    static properties = {
        ...super.properties,
        memberData: { type: Object, state: true },
        dashboard: { type: String },
        membership: { type: Object },
        provisions: { type: Object, state: true },
        user: { type: Object, state: true },
        hardlinks: { type: Object, state: true },
        panel: { type: String },
        view: { type: String },
        panels: { type: Object },
        name: { type: String },
        restUrl: { type: String },
        action: { type: String },
        nonce: { type: String },
    };
    connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
        this._memberData = new ContextConsumer(this, { context: memberContext, callback: this._handleContextUpdate.bind(this), subscribe: true });
        this._populateStateFromContext();
    }
    _updateContext(props) {
        this.eventManager.emit(`allin-membership-${this.name}-update`, props);
    }
    _handleContextUpdate(value) {
        this.memberData = value;
        this._populateStateFromContext();
    }
    _setDocumentTitle(title) {
        document.title = `${title} - All In`;
    }
    _populateStateFromContext() {
        if (!this.memberData) {
            this.memberData = this._memberData.value;
        }
        this._beforeContextUpdate();
        ({
            name: this.name,
            membership: this.membership,
            user: this.user,
            dashboard: this.dashboard,
            panel: this.panel,
            view: this.view,
            panels: this.panels,
            restUrl: this.restUrl,
            action: this.action,
            nonce: this.nonce,
            provisions: this.provisions,
            hardlinks: this.hardlinks
        } = this.memberData);
        this._afterContextUpdate();
        this.requestUpdate();
    }
    async _afterContextUpdate() {
        // Hook for subclasses
    }
    _beforeContextUpdate() {
        //Hook for subclasses
    }
};
